export const ArrowDownIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 6.81252L0 1.81252L0.895833 0.916687L5 5.04169L9.10417 0.93752L10 1.83335L5 6.81252Z"
        // fill="white"
      />
    </svg>
  );
};
